import { styled } from 'styled-components';
import { Colors } from '../../../../play-core/styles/Colors';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { SecondaryButton } from '../ClickableComponents/Button';
import { containerPadding } from '../PlayContainer/PlayContainer';
export const Layout = styled.div.withConfig({
  displayName: "DateSelectionstyles__Layout",
  componentId: "sc-1pturpb-0"
})(["display:flex;flex-wrap:wrap;justify-content:flex-start;", "{margin-top:0;}"], Viewports.for('small'));
export const DatePickerWrapper = styled.div.withConfig({
  displayName: "DateSelectionstyles__DatePickerWrapper",
  componentId: "sc-1pturpb-1"
})(["position:", ";width:100%;&:not(:focus-within){input{background:", ";border-color:transparent;}}> *{opacity:", ";}"], ({
  isPickerRevealed
}) => isPickerRevealed ? 'static' : 'relative', Colors.GREY_3a3a3a, ({
  isPickerRevealed
}) => isPickerRevealed ? 1 : 0);
export const CalendarSelection = styled.div.withConfig({
  displayName: "DateSelectionstyles__CalendarSelection",
  componentId: "sc-1pturpb-2"
})(["position:relative;padding-top:28px;padding-bottom:28px;width:380px;", "{width:100%;padding:", "px;}display:grid;grid-auto-flow:column;grid-gap:8px;"], Viewports.for('small'), containerPadding.small);
export const IconButton = styled(SecondaryButton).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "DateSelectionstyles__IconButton",
  componentId: "sc-1pturpb-3"
})(["flex-basis:0;"]);
export const RevealPickerButton = styled(SecondaryButton).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "DateSelectionstyles__RevealPickerButton",
  componentId: "sc-1pturpb-4"
})(["opacity:1;position:absolute;pointer-events:none;"]);